// Registers the embertime service worker (push + offline app shell).
// Called once at app start in production builds and from the push
// opt-in; both paths share this idempotent logic.

/** Idempotently register the embertime service worker within the
 * document base (e.g. /zeit/). Resolves with the registration, or null
 * when service workers are unsupported or registration fails. */
export async function registerAppServiceWorker(
  nav: Navigator = navigator,
  doc: Pick<Document, 'baseURI'> = document,
): Promise<ServiceWorkerRegistration | null> {
  if (!('serviceWorker' in nav)) return null
  const swPath = new URL('sw.js', doc.baseURI).pathname
  const scope = new URL('.', doc.baseURI)
  try {
    const existing = await nav.serviceWorker.getRegistration(swPath)
    // getRegistration also matches a parent scope, e.g. the Bridge worker.
    if (existing?.scope === scope.href) return existing
    return await nav.serviceWorker.register(swPath, { scope: scope.pathname })
  } catch {
    return null
  }
}
